"use client";

import { useState } from "react";
import { useTranslation } from "react-i18next";
import Button from "@/components/library/Button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface DeleteSmsSettingsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => Promise<void>;
}

export default function DeleteSmsSettingsDialog({
  open,
  onOpenChange,
  onConfirm,
}: DeleteSmsSettingsDialogProps) {
  const { t } = useTranslation("partners");
  const { t: ct } = useTranslation("common");
  const [deleting, setDeleting] = useState(false);

  const handleConfirm = async () => {
    if (deleting) return;
    setDeleting(true);
    try {
      await onConfirm();
    } finally {
      setDeleting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(next) => !deleting && onOpenChange(next)}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("smsIntegration.deleteDialog.title")}</DialogTitle>
          <DialogDescription>{t("smsIntegration.deleteDialog.description")}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button type="secondary" onClick={() => onOpenChange(false)} disabled={deleting}>
            {ct("cancel")}
          </Button>
          <Button type="primary" destructive onClick={handleConfirm} disabled={deleting}>
            {ct("remove")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
